// extracted by mini-css-extract-plugin
export default {"headerComponentWrapper":"LeagueNameFrame_headerComponentWrapper__mTG9w"};